import { render } from "./ClaimsInstructions.vue?vue&type=template&id=1009d798&scoped=true&ts=true"
import script from "./ClaimsInstructions.vue?vue&type=script&lang=ts"
export * from "./ClaimsInstructions.vue?vue&type=script&lang=ts"

import "./ClaimsInstructions.vue?vue&type=style&index=0&id=1009d798&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1009d798"]])

export default __exports__